import React from 'react';
import { stages } from '../../data/stages';
import { SectionHeading } from '../ui/SectionHeading';
export function StageRail() {
  return <section className="bg-cream" aria-labelledby="stages-heading" data-id="element-230" data-mp="ikuv8m2oz4rl">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-231" data-mp="wjb70rfevlgl">
        <SectionHeading eyebrow="What’s actually happening" title="Four stages, and the words for each one." intro="Most of the confusion around this comes from one word being used for a decade of different things. Here is the map, with no product attached to it." data-id="element-232" data-mp="shppgsrxmj02" />

        <ol className="mt-16 grid gap-px overflow-hidden rounded-brand border border-ink/15 bg-ink/15 md:grid-cols-2 xl:grid-cols-4" data-id="element-233" data-mp="1g7k0r5wlrzi7">
          {stages.map((stage, index) => <li key={stage.id} className="flex flex-col bg-cream-light p-8" data-id="element-234" data-mp="1p7qacgp6kfc3" data-mpi={index}>
              <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-235" data-mp="1p805eip31con">
                {String(index + 1).padStart(2, '0')} · {stage.ages}
              </p>
              <h3 className="mt-4 font-serif text-2xl leading-snug text-ink" data-id="element-236" data-mp="1glij6i0kg0zz">{stage.name}</h3>
              <p className="mt-4 font-serif text-lg italic leading-snug text-brick" data-id="element-237" data-mp="1lklehaqqusur">
                {stage.physiology}
              </p>
              <p className="mt-5 text-[0.9375rem] leading-relaxed text-ink-soft" data-id="element-238" data-mp="1qkpy39my83p7">{stage.detail}</p>
              <div className="rule mt-auto pt-5" data-id="element-239" data-mp="1vfn3m6l0ruxc">
                <p className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-240" data-mp="1zk37y3eziuag">
                  Care looks like
                </p>
                <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink" data-id="element-241" data-mp="24gl8er3a86gz">
                  {stage.careLooksLike}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}